import { useMutation } from "react-query";
import axios from "axios";

const useDelete = (url, options = {}) => {
    const token = document.cookie.split(`jwt=`).pop().split(';').shift();
    return useMutation(
        async ( body) => {
            const { data } = await axios.delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                data: body
            });
            return data;
        },
        {
            ...options,
        }
    );
};

export default useDelete;
